<template>
  <div class="custom-list-mapping">
    <div class="custom-list-mapping-container">
      <div
        v-for="(item, index) in mappingObj"
        :key="item.key"
        class="custom-list-mapping-row"
      >
        <label>{{ item.label }} <b v-if="item.required">*</b></label>
        <custom-dropdown
          :list="columnOptions"
          :selected="getSelectedOption(mappingObj[index].mapWith)"
          :default-label="item.required ? 'Select column' : 'Select column (optional)'"
          :default-style="dropdownStyle"
          @select="handleSelect(index, $event)"
          @deselect="handleDeselect(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropdown from '@/components/common/customDropdown.vue'

export default {
  name: 'CustomListMapping',
  components: {
    CustomDropdown
  },
  props: {
    fileCol: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      mappingObj: [
        {
          label: 'Value',
          key: 'name',
          mapWith: null,
          required: true
        },
        {
          label: 'Abbreviation',
          key: 'abbreviation',
          mapWith: null,
          required: false
        }
      ],
      dropdownStyle: {
        dropDownWidth: '100%',
        labelHeight: '36px',
        ddLabelFontSize: 'var(--text-xs2)',
        borderColor: '#e5e7eb',
        backGroundColor: '#f9fafb'
      }
    }
  },
  computed: {
    canSave () {
      return this.mappingObj.every(item => !item.required || item.mapWith)
    },
    columnOptions () {
      return this.fileCol.map(col => ({
        id: col.columnNumber,
        name: col.label
      }))
    }
  },
  methods: {
    getSelectedOption (columnNumber) {
      if (!columnNumber) return {}
      return this.columnOptions.find(option => option.id === Number(columnNumber)) || {}
    },
    handleSelect (index, option) {
      this.$set(this.mappingObj[index], 'mapWith', option?.id || null)
    },
    handleDeselect (index) {
      this.$set(this.mappingObj[index], 'mapWith', null)
    },
    getMappingPayload () {
      const mapping = {}
      this.mappingObj.forEach((item) => {
        if (!item.mapWith) return
        mapping[item.key] = {
          columnNumber: Number(item.mapWith)
        }
      })
      return mapping
    },
    emitMappingState () {
      this.$emit('mapping-state', {
        canSave: this.canSave,
        mapping: this.getMappingPayload()
      })
    },
    initializeMappingDefaults () {
      this.mappingObj.forEach((item) => {
        item.mapWith = null
      })
      const normalized = this.fileCol.map(item => item.label.toLowerCase())
      this.mappingObj.forEach((item) => {
        const index = normalized.findIndex(col => col === item.key)
        if (index !== -1) {
          item.mapWith = this.fileCol[index].columnNumber
        }
      })
    }
  },
  watch: {
    mappingObj: {
      deep: true,
      handler () {
        this.emitMappingState()
      }
    },
    fileCol: {
      deep: true,
      handler () {
        this.initializeMappingDefaults()
        this.emitMappingState()
      }
    }
  },
  mounted () {
    this.initializeMappingDefaults()
    this.emitMappingState()
  }
}
</script>

<style lang="scss" scoped>
.custom-list-mapping {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 14px;
  background: #ffffff;
  &-container {
    overflow: visible;
  }
  &-row {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    label {
      width: 110px;
      color: #374151;
      font-size: var(--text-s);
      b {
        color: var(--brand-color);
      }
    }
    ::v-deep .custom-dropdown-container {
      flex-grow: 1;
    }
  }
}
</style>
